/* eslint-disable import/no-extraneous-dependencies */
import * as React from 'react';
import styled from 'styled-components';
import Switch from '@mui/material/Switch';
import { styleVariables } from '../common/constants';

const IOSSwitch = styled((props) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(() => ({
  width: '42px !important',
  height: '22px !important',
  padding: '2px !important',
  '& .MuiSwitch-switchBase': {
    padding: 0,
    margin: 2,
    transitionDuration: '300ms',
    '&.Mui-checked': {
      transform: 'translateX(18px)',
      color: '#fff',
      '& + .MuiSwitch-track': {
        backgroundColor: `${styleVariables.fillSuccess}`,
        border: `1px solid ${styleVariables.inkOnBackground60}`,
        opacity: 1,
      },
      '&.Mui-disabled + .MuiSwitch-track': {
        opacity: 0.5,
      },
    },
    '&.Mui-focusVisible .MuiSwitch-thumb': {
      boxShadow: `${styleVariables.buttonOutlinedFocusBoxShadow}`,
      height: '14px',
      width: '14px',
      marginLeft: '3px',
      marginTop: '3px',
    },
    '&.Mui-disabled .MuiSwitch-thumb': {
      color: `${styleVariables.inkOnBackground60}`,
    },
    '&.Mui-disabled + .MuiSwitch-track': {
      opacity: 0.7,
    },
  },
  '& .MuiSwitch-thumb': {
    boxSizing: 'border-box',
    border: `1px solid ${styleVariables.inkOnBackground60}`,
    width: 20,
    height: 20,
  },
  '& .MuiSwitch-track': {
    borderRadius: 22 / 2,
    backgroundColor: `${styleVariables.detail1Opaque}`,
    opacity: 1,
    border: `1px solid ${styleVariables.inkOnBackground60}`,

  },
}));

export default IOSSwitch;
